import { VGLClientSendPalletsData } from '../types';

export const vglClientSendPalletsDataItemToVGLClientPalletsItemMapper = (
   sendPalletsDataItem: VGLClientSendPalletsData,
) => ({
   ['typ palety']: sendPalletsDataItem['typ palety'],
   ['ilość']: sendPalletsDataItem['ilość'],
});
